import connectionProxy from './connectionProxy'

export const getProducts = areaId => {
  return connectionProxy.http.get(`/areas/${areaId}/produtos_controlados`)
}

export const getProduct = (areaId, id) => connectionProxy.http.get(`/areas/${areaId}/produtos_controlados/${id}`)


export const getControlledComponentsCollection = () => {
  return connectionProxy.http.get(`/produtos_controlados/colecao_componentes_controlados`)
}

export const getSupervisoriesCollection = () => {
  return connectionProxy.http.get(`/produtos_controlados/colecao_orgaos_reguladores`)
}



// WEBPACK FOOTER //
// ./src/api/controlledProducts.js